import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=4c13c674&scoped=true&"
import script from "./ModalHeader.vue?vue&type=script&lang=ts&"
export * from "./ModalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=4c13c674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c13c674",
  null
  
)

export default component.exports